import React, { lazy, Suspense, useEffect, useState } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import Grid from "@material-ui/core/Grid";

const Map = lazy(() => import(/* webpackChunkName: "reactOverviewPlanMap" */ "./map"));
const Slider = lazy(() =>
	import(/* webpackChunkName: "reactOverviewPlanSlider" */ "./slider")
);

const useStyles = makeStyles(theme => ({
	root: {
		marginLeft: -16,
		marginRight: -16,
		maxWidth: 1780,
		width: "auto",
		[theme.breakpoints.up("sm")]: {
			marginLeft: -24,
			marginRight: -24
		},
		[theme.breakpoints.up("md")]: {
			marginLeft: "auto",
			marginRight: "auto"
		}
	},
	item: {
		position: "relative"
	}
}));

const OverviewPlan = ({ animationID, items, lang }) => {
	const { REACT_APP_PATH } = process.env;
	const [animationData, setAnimationData] = useState();
	const [selected, setSelected] = useState();
	const css = useStyles();

	useEffect(() => {
		if (!items) return;

		setSelected(items?.[0]?.textcontent?.items?.find(e => e.name === "identifier")?.text);
	}, [items]);

	useEffect(() => {
		const fetchData = async () => {
			let fetchURL = `${REACT_APP_PATH}/animationV3.json.api?lang=${lang}`;

			if (animationID) fetchURL += `&id=${animationID}`;

			const response = await fetch(fetchURL);

			if (response.status !== 200) {
				throw new Error("No animation found!");
			}

			const data = await response.json();

			setAnimationData(data);

			return data;
		};

		if (animationID) {
			fetchData();
		}
	}, [REACT_APP_PATH, animationID, lang]);

	return (
		<Grid className={css.root} container>
			<Grid className={css.item} item xs={12} md={6}>
				<Suspense fallback={<></>}>
					<Map
						animation={animationData?.items?.[0]}
						selected={selected}
						setSelected={setSelected}
					/>
				</Suspense>
			</Grid>
			<Grid className={css.item} item xs={12} md={6}>
				<Suspense fallback={<></>}>
					<Slider items={items} selected={selected} setSelected={setSelected} />
				</Suspense>
			</Grid>
		</Grid>
	);
};

export default OverviewPlan;
